import React from "react";
import WhatsAppIcon from "./WhatsAppIcon";
import { useLang } from "../contexts/LanguageContext";

const WA_URL = `https://wa.me/966545670477?text=${encodeURIComponent("أبغى أستفسر عن رحلة — من الموقع")}`;

/**
 * Subtle floating WhatsApp fallback — icon-only bubble.
 * Dana is the primary CTA; this is only a secondary "prefer WhatsApp" option.
 */
export default function FloatingWhatsApp() {
  const { isAr } = useLang();
  return (
    <a
      href={WA_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp"
      aria-label={isAr ? "تواصل عبر واتساب" : "Chat on WhatsApp"}
      title={isAr ? "تواصل عبر واتساب" : "Chat on WhatsApp"}
      className={`fixed bottom-5 ${isAr ? 'left-5' : 'right-5'} z-40`}
    >
      <span
        className="relative inline-flex items-center justify-center rounded-full shadow-lg hover:scale-105 active:scale-95 transition-transform duration-300"
        style={{
          width: 52,
          height: 52,
          background: '#25D366',
          color: '#FFFFFF',
          boxShadow: '0 6px 18px -6px rgba(37,211,102,0.55), 0 4px 10px rgba(0,0,0,0.18)',
        }}
      >
        <WhatsAppIcon size={24} color="#FFFFFF" />
      </span>
    </a>
  );
}
